import { render, staticRenderFns } from "./StatisticsCompare.vue?vue&type=template&id=5a7a66b0&scoped=true"
import script from "./StatisticsCompare.vue?vue&type=script&lang=js"
export * from "./StatisticsCompare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7a66b0",
  null
  
)

export default component.exports